<div class="add-container">
    <h1 class="add-title">Asignează în masă cereri</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="add-field">
            <mat-form-field class="w-100">
                <mat-label>Compartiment/Birou/Serviciu</mat-label>
                <mat-select formControlName="directie_id" (openedChange)="onCompartimentSelectClosed()"
                    (selectionChange)="onCompartimentChange($event.value)">
                    <mat-form-field class="px-2 w-100 sticky-input">
                        <input matInput [formControl]="compartimenteControl" (keydown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </mat-form-field>

                    <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                        <span>No results found</span>
                    </mat-option>

                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                    <mat-option *ngFor="let departament of filteredCompartimente" [value]="departament.id_compartiment">
                        {{ departament.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                    Câmp obligatoriu
                </mat-error>
            </mat-form-field>
        </div>

        <div class="add-field">
            <mat-form-field>
                <mat-label>Operator</mat-label>
                <mat-select (openedChange)="onUsersSelectClosed()" formControlName="operator">
                    <mat-form-field class="px-2 w-100 sticky-input">
                        <input matInput [formControl]="usersControl" (keydown)="$event.stopPropagation()"
                            (click)="$event.stopPropagation()" />
                    </mat-form-field>

                    <mat-option *ngIf="filteredUsers.length === 0" disabled>
                        <span>No results found</span>
                    </mat-option>

                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                    <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                        {{ user.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!form.controls['operator'].valid && form.controls['operator'].touched">
                    Câmp obligatoriu
                </mat-error>
            </mat-form-field>
        </div>

        <div class="add-action-btns">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>